// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_role.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { AdminRoleService } from "./admin_role_pb";

/**
 * ListRoles returns every role with the permissions granted to it.
 *
 * @generated from rpc travplaces.v1.AdminRoleService.ListRoles
 */
export const listRoles = AdminRoleService.method.listRoles;

/**
 * ListPermissions returns every permission the application defines, with the
 * labels to show beside each, so the console can render a picker without
 * hard-coding the list.
 *
 * @generated from rpc travplaces.v1.AdminRoleService.ListPermissions
 */
export const listPermissions = AdminRoleService.method.listPermissions;

/**
 * CreateRole adds a role and grants it the given permissions.
 *
 * @generated from rpc travplaces.v1.AdminRoleService.CreateRole
 */
export const createRole = AdminRoleService.method.createRole;

/**
 * UpdateRole renames a role and replaces the permissions granted to it.
 *
 * The permission set is replaced wholesale rather than patched: the console
 * edits it as a set of tick boxes, and sending the result of that edit is
 * both what the caller means and what makes the call idempotent.
 *
 * @generated from rpc travplaces.v1.AdminRoleService.UpdateRole
 */
export const updateRole = AdminRoleService.method.updateRole;

/**
 * DeleteRole removes a role. Refused while any account still holds it —
 * deleting it would leave those accounts with no role and no way in.
 *
 * @generated from rpc travplaces.v1.AdminRoleService.DeleteRole
 */
export const deleteRole = AdminRoleService.method.deleteRole;
